
import { ConfiguracionesService } from '../../../../shared/configuraciones.service';
import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { Injectable } from '@angular/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import { MatDialog, MatDialogRef,MAT_DIALOG_DATA} from '@angular/material/dialog'
import { formatDate } from '@angular/common';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DialogAgregarConductor } from '../dialogAgregarConductor/dialogAgregarConductor.component';

export interface DialogDataVh {
  idTercero: string;
  idPropietario: string;
  nombrePropietario: string;
  apellidosPropietario: string;
  id: string;
  placa: string;
  modelo: string;
  marca: string;
  aseguradora: string;
  vensoat: string;
  ventecno: string;
  linea: string;
  version: string;
  carga: string;
  volumen: string;
  configuracion: string;
  estado: string;
  clase: string;
}

@Component({
  selector: 'app-DialogAgregarDocumentos',
  templateUrl: './DialogAgregarDocumentos.component.html',
  styleUrls: ['./DialogAgregarDocumentos.component.scss'],
  encapsulation: ViewEncapsulation.None
})
@Injectable()
export class DialogAgregarDocumentos implements OnInit {
  idTercero: string;
  idPropietario: string;
  nombrePropietario: string;
  apellidosPropietario: string;
  id: string;
  placa: string;
  modelo: string;
  marca: string;
  aseguradora: string;
  vensoat: string;
  ventecno: string;
  linea: string;
  version: string;
  carga: string;
  volumen: string;
  configuracion: string;
  estado: string;
  clase: string;
  public marcas;
  public marcafm;
  public confifm;
  public confisvh;
  public estados;
  public soatvenfm;
  public tecnovenfm;
  public modelos;
  public clases;
  public modelofm;
  public imgEstadofm;
  public estadofm;
  public clasefm;
  public codigovehiculo;
  private s_ano;
  private s_mes;
  private s_dia;
  private v_ano;
  private v_mes;
  private v_dia;
  private anos;
  private dias;
  private meses;
  constructor(public dialogRef: MatDialogRef<DialogAgregarDocumentos>, 
     @Inject(MAT_DIALOG_DATA) public data: DialogDataVh,private configuracionesService: ConfiguracionesService, public toastr: ToastrManager,public dialogagregarVh: MatDialog,public dialogagregar: MatDialog) {}


  ngOnInit(): void {

 this.descargarConVh()
 this.descargarMarcas()
 this.descargarConfiguracion()
 this.descargarEstados()
 this.descargarModelos()
 this.descargarClase()
 this.descargaranos()
 this.descargardias()
 this.descargarmeses()

 this.marcafm=this.data.marca
 this.confifm=this.data.configuracion
 this.estadofm="Activo"
 this.modelofm=this.data.modelo
 this.imgEstadofm="/assets/activo.png"
 
  }

  onNoClick(): void {
    console.log('cerrado');
    this.dialogRef.close();

    this.dialogagregar.open(DialogAgregarConductor, {
      width: '850px',
      data: {},
    
      });
  
  }
 
  crearTipoDocumento(data: any) {
   


    if(data.placa && 
      this.modelofm &&  
      this.marcafm &&
      data.aseguradora &&
      data.linea &&
     this.s_ano &&
     this.s_mes &&
     this.s_dia &&
     this.v_ano &&
     this.v_mes &&
     this.v_dia &&
     data.version &&
     data.carga &&
     data.volumen &&
     this.confifm &&
     this.estadofm &&
     this.clasefm ) {

      if(this.modelofm) {

          
    var conop = {
      con: this.codigovehiculo+1

    }

    this.configuracionesService.incrementarvehiculonv(conop)


    var aseguradora = data.aseguradora;
    var mayus = aseguradora.substring(0, 1).toUpperCase();
    var resto = aseguradora.substring(1, aseguradora.length).toLowerCase();
    mayus.concat(resto.toString());

    
    var linea = data.linea;
    var mayuslinea = linea.substring(0, 1).toUpperCase();
    var restolinea = linea.substring(1, linea.length).toLowerCase();
    mayuslinea.concat(restolinea.toString());
        var tipoDoc = {
          id: this.codigovehiculo,
          placa: data.placa,
          modelo:   this.modelofm,
          marca: this.marcafm,
          aseguradora:  mayus.concat(resto.toString()),
          sdia: this.s_dia ,
          smes:  this.s_mes,
          sano:  this.s_ano,
          vdia: this.v_dia ,
          vmes:  this.v_mes,
          vano:  this.v_ano,
          linea:  mayuslinea.concat(restolinea.toString()),
          version: data.version,
          carga: data.carga,
          volumen: data.volumen,
          configuracion: this.confifm,
          estado: this.estadofm,
          imgEstado: this.imgEstadofm,
          clase:  this.clasefm,
          idTercero: data.idTercero,
          idPropietario: data.idPropietario,
          nombrePropietario: data.nombrePropietario,
          apellidosPropietario: data.apellidosPropietario,
          agencia:localStorage.getItem("agencia"),
          negocio: localStorage.getItem("negocio"),
        }
  
        console.log('tipodocumento pag terceros',tipoDoc);
        var hoy = new Date();
        var minuto=  hoy.getMinutes() 
        var segundos=hoy.getSeconds()
    
        var minutefinal="00"
        var segundofinal="00"
        if(minuto<10){
    
          minutefinal="0"+minuto
        }else{
          minutefinal=String(minuto)
        }
        if(segundos<10){
    
          segundofinal="0"+segundos
        }else{
          segundofinal=String(segundos)
        }
        var hora = hoy.getHours() + ':' + minutefinal + ':' + segundofinal;
        var auditria = {
          id:this.codigovehiculo,
          usuario:  localStorage.getItem("responsable"),
          hora:  hora,
          fechahora: formatDate(hoy, 'yyyy-MM-dd HH:mm:ss', 'en-US'),
          fecha: formatDate(hoy, 'yyyy-MM-dd', 'en-US'),
          movimiento:  'Agregar',
          placa: data.placa,
          modelo:   this.modelofm,
          marca: this.marcafm,
          aseguradora:  mayus.concat(resto.toString()),
          sdia: this.s_dia ,
          smes:  this.s_mes,
          sano:  this.s_ano,
          vdia: this.v_dia ,
          vmes:  this.v_mes,
          vano:  this.v_ano,
          linea:  mayuslinea.concat(restolinea.toString()),
          version: data.version,
          carga: data.carga,
          volumen: data.volumen,
          configuracion: this.confifm,
          estado: this.estadofm,
          imgEstado: this.imgEstadofm,
          clase:this.clasefm,
          idTercero: data.idTercero,
          idPropietario: data.idPropietario,
          nombrePropietario: data.nombrePropietario,
          apellidosPropietario: data.apellidosPropietario,
          agencia:localStorage.getItem("agencia"),
          negocio: localStorage.getItem("negocio"),
        }
    
        this.configuracionesService.crearAuditriaVehiculo(auditria)
        this.configuracionesService.crearVehiculonv(tipoDoc)
        this.toastr.successToastr("Vehículo:  creado con éxito", 'Notificación');
        this.dialogRef.close();
    

      }else{
        this.toastr.errorToastr("Ingresar Vehículo", 'Notificación');
  
      } 

    }else{
      this.toastr.errorToastr("Todos los campos de un formulario son obligatorios", 'Notificación');

    } 



  }

  descargarEstados() {

    this.configuracionesService.getEstado().subscribe(configuraciones => {
  

      this.estados=configuraciones
    
  
    
    });
  }

  descargarMarcas() {

    this.configuracionesService.getTiposMarcas().subscribe(configuraciones => {
  

      this.marcas=configuraciones
    
  
    
    });
  }


  descargarClase() {

    this.configuracionesService.getClasesVehiculos().subscribe(configuraciones => {
  

      this.clases=configuraciones
    
  
    
    });
  }


  descargarConfiguracion() {

    this.configuracionesService.getconfiguracionesVh().subscribe(configuraciones => {
  

      this.confisvh=configuraciones
    
  
    
    });
  }

  sestado(estado: any) {

    this.estadofm=estado

    if(estado=="Activo"){
         this.imgEstadofm="/assets/activo.png"
    }

    if(estado=="Bloqueado"){
      this.imgEstadofm="/assets/bloqueado.png"
    }

    if(estado=="Novedad"){
      this.imgEstadofm="/assets/novedad.png"
    }

  if(estado=="Inactivo")
      {
    this.imgEstadofm="/assets/inactivo.png"
   }

  }

  descargarModelos() {

    this.configuracionesService.getModelos().subscribe(configuraciones => {
  
      this.modelos=configuraciones
      console.log('modelos',configuraciones);
    });
  }

  smodelo(modelo: any) {

    this.modelofm=modelo
   
  }

  smarca(marca: any) {

    this.marcafm=marca

  }

  sconfi(confi: any) {

    this.confifm=confi

  }

  sclase(clase: any) {

    this.clasefm=clase

  }

  descargarmeses() {

    this.configuracionesService.getMes().subscribe(configuraciones => {

      this.meses=configuraciones
  
  
    });
  }

  descargardias() {

    this.configuracionesService.getdia().subscribe(configuraciones => {

      this.dias=configuraciones
  

    });
  }

  descargarConVh() {

    this.configuracionesService.getvehiculoConNv().subscribe(tipos => {

      for (let tipo of tipos) {

           this.codigovehiculo=tipo.con
      
      }  


    });
  }


  descargaranos() {

    this.configuracionesService.getanos().subscribe(configuraciones => {

      this.anos=configuraciones
  
   
    });
  }


  sfdia(dato: any) {

    this.s_dia=dato

  }
  sfmes(dato: any) {

    this.s_mes=dato

  }

  sfano(dato: any) {

    this.s_ano=dato

  }


  svdia(dato: any) {

    this.v_dia=dato

  }
  svmes(dato: any) {

    this.v_mes=dato

  }

  svano(dato: any) {

    this.v_ano=dato

  }
  
}
